import React, { Component } from "react";
import HomeForm from "../HomeForm/HomeForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ReportedPage
Description : Componente que contienen el formulario de la pantalla Reported 
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se llama al componente ReportedForm
================================================================================ */
class HomePage extends Component {
    render() {
        return (
            <div style={{width:'100%'}}>
                <HomeForm />
            </div>
        )
    }
}

export default HomePage;